import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Note } from '@/utils/types';
import { getNotes } from '@/api/notes';

export default function NoteList() {
  const [notes, setNotes] = useState<Note[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchNotes() {
      try {
        setLoading(true);
        setError(null);
        const data = await getNotes();
        setNotes(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load notes');
        setNotes([]);
      } finally {
        setLoading(false);
      }
    }
    fetchNotes();
  }, []);

  if (loading) {
    return (
      <div className="text-gray-400 py-8">Loading notes…</div>
    );
  }

  if (error) {
    return (
      <div className="text-red-400 py-8" role="alert">
        {error}
      </div>
    );
  }

  if (notes.length === 0) {
    return (
      <div className="text-gray-400 py-8">No notes yet.</div>
    );
  }

  return (
    <ul className="space-y-4 mt-6">
      {notes.map((note) => (
        <li key={note.id}>
          <Link
            to={`/backend/notes/${note.id}`}
            className="block rounded-lg border border-gray-700 bg-gray-800 p-4 transition-colors hover:border-indigo-500 hover:bg-gray-700"
          >
            <h3 className="text-lg font-semibold text-white">{note.title}</h3>
            <p className="text-gray-300 mt-1 text-sm">{note.content}</p>
            <p className="text-gray-500 text-xs mt-2">
              Updated {new Date(note.updatedAt).toLocaleString()}
            </p>
          </Link>
        </li>
      ))}
    </ul>
  );
}
